import { networkService as network } from '@/services';
import store from '@/store';

export const userService = {
  getUserSelf() {
    return new Promise((resolve, reject) => {
      network
        .get('/auth/me')
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUserId() {
    return new Promise((resolve, reject) => {
      network
        .get('/auth/me')
        .then((data) => {
          resolve(data.data.id);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUser(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/users/${id}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUserByLocale(id, locale) {
    return new Promise((resolve, reject) => {
      network
        .get(`/users/${id}?locale=${locale}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUserList(page, take) {
    return new Promise((resolve, reject) => {
      network
        .get(`/users/users?order=ASC&page=${page}&take=${take}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllUsers({ order = 'ASC', page = 1, take = 10 }) {
    return new Promise((resolve, reject) => {
      network
        .get(`/users/all?order=${order}&page=${page}&take=${take}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateUser({ id, locale, firstName, lastName, username, phone, email, emailVerified, avatar, gender }) {
    return new Promise((resolve, reject) => {
      const request = { id, locale, firstName, lastName, username, phone, email, emailVerified, avatar, gender };
      network
        .put(`/users/${id}`, request)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePassword({ id, password, locale }) {
    return new Promise((resolve, reject) => {
      network
        .put(`/users/update-password/${id}?password=${password}&locale=${locale}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  changePassword(currentPassword, newPassword) {
    return new Promise((resolve, reject) => {
      network
        .put(`/users/changePassword`, { currentPassword, newPassword })
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  refreshCurrentUser() {
    network.get('/users').then((userResponse) => {
      const userData = userResponse.data;
      store.commit('user/set', userData);
    });
  },
  removeUser(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/users/${id}`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
